import styled from 'styled-components';
export var LoaderWrapper = styled.div.withConfig({
  componentId: "x9w6ln-0"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);